import { apiRequest } from "./client";

// Сводка по получателю — зеркалит backend RecipientDataResponse
// (см. api/v1/privacy.py). Все счётчики неотрицательные.
export interface RecipientData {
  email: string;
  dispatches: number;
  dispatches_already_erased: number;
  dispatch_recipients: number;
  viewer_sessions: number;
  events: number;
  otp_codes: number;
}

export const privacyApi = {
  getRecipientData: (email: string) =>
    apiRequest<RecipientData>(
      `/privacy/recipient-data?email=${encodeURIComponent(email)}`,
    ),
  eraseRecipient: (email: string) =>
    apiRequest<RecipientData>("/privacy/erase-recipient", {
      method: "POST",
      body: { email },
    }),
};
